/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'people.menu.renotify.flag.description':
    'Vamos a enviar un recordatorio a todo el mundo por correo electrónico. Esta acción puede tardar hasta un minuto.',
  'people.menu.renotify.flag.description.confluence': 'Enviar recordatorio a los compañeros de equipo',
  'people.menu.renotify.flag.title': 'Enviando recordatorios',
  'people.menu.renotify.flag.title.confluence': 'Reenviando correo electrónico de invitación',
  'people.menu.renotify.menu.description':
    '{userCount, plural, one {{userCount,number} persona no ha aceptado su invitación de {product}. Comprueba quién falta y envíale un recordatorio.} other {{userCount,number} personas no han aceptado su invitación de {product}. Comprueba quiénes faltan y envíales un recordatorio.}}',
  'people.menu.renotify.menu.description.confluence':
    'Algunas personas no han aceptado su invitación de Confluence. Comprueba quienes faltan y envíales un recordatorio.',
  'people.menu.renotify.menu.dismiss': 'Descartar',
  'people.menu.renotify.menu.dismiss.confluence': 'Ahora no',
  'people.menu.renotify.menu.remind': 'Recordar a los miembros del equipo',
  'people.menu.renotify.menu.remind.confluence': 'Enviar recordatorio a los compañeros de equipo',
  'people.menu.renotify.menu.title': '¿Está todo el mundo listo?',
  'people.menu.renotify.modal.copied': 'Enlace copiado',
  'people.menu.renotify.modal.copy': 'Copiar enlace de invitación',
  'people.menu.renotify.modal.description':
    'Podemos enviar un recordatorio por correo electrónico a los miembros que faltan o puedes compartir el enlace de invitación por tu cuenta.',
  'people.menu.renotify.modal.description.confluence':
    'Vuelve a enviar el correo electrónico de invitación o copia y comparte el enlace de invitación.',
  'people.menu.renotify.modal.dismiss': 'Cancelar',
  'people.menu.renotify.modal.resend': 'Enviar recordatorio',
  'people.menu.renotify.modal.resend.confluence': 'Reenviar invitación',
  'people.menu.renotify.modal.title': 'Recordar a los miembros que faltan',
  'people.menu.renotify.modal.title.confluence': 'Enviar recordatorio a los compañeros de equipo que faltan',
  'ptc.pm.collaborators.title': 'Tus colaboradores',
  'ptc.pm.error-heading': 'Algo ha ido mal',
  'ptc.pm.error-image-alt-text': 'Un robot roto y varias personas ocupadas intentando arreglarlo.',
  'ptc.pm.error-text':
    'Realizamos un seguimiento de estos errores, pero ponte en contacto con nosotros si actualizar no soluciona el problema',
  'ptc.pm.num-members':
    '{memberCount, plural, one {{memberCount,number} miembro} other {{memberCount,number} miembros}}',
  'ptc.pm.people': 'Personas',
  'ptc.pm.teams': 'Equipos',
  'ptc.pm.view-your-profile': 'Ver tu perfil',
  'ptc.pm.your-teams.title': 'Tus equipos',
};
